const MAX_CANVAS_AREA = 1000000

export class CanvasManager {
  constructor(canvas) {
    this._canvas = canvas
  }

  async updateImages(image, mask) {
    this._image = image
    this._mask = mask
    this._updateCanvasWidth()
  }

  updateDpr(canvasWidth, canvasHeight, dpr) {
    const canvas = this._canvas

    /* Limit canvas area to MAX_CANVAS_AREA to improve performance */
    let effectiveDpr = dpr
    const potentialArea = dpr * dpr * canvasWidth * canvasHeight
    if (potentialArea > MAX_CANVAS_AREA) {
      effectiveDpr = Math.sqrt(MAX_CANVAS_AREA / (canvasWidth * canvasHeight))
    }

    canvas.width = canvasWidth * effectiveDpr
    canvas.height = canvasHeight * effectiveDpr
  }

  _updateCanvasWidth() {
    const canvas = this._canvas
    this._context = canvas.getContext('2d')

    /* Save image as ImageData */
    this._context.clearRect(0, 0, canvas.width, canvas.height)
    this._context.drawImage(this._image, 0, 0, canvas.width, canvas.height)
    this._imageData = this._context.getImageData(0, 0, canvas.width, canvas.height)

    /* Save mask as ImageData */
    this._context.clearRect(0, 0, canvas.width, canvas.height)
    this._context.drawImage(this._mask, 0, 0, canvas.width, canvas.height)
    this._maskData = this._context.getImageData(0, 0, canvas.width, canvas.height)

    /* Save create image data as ImageData */
    this._context.clearRect(0, 0, canvas.width, canvas.height)
    this._drawData = this._context.getImageData(0, 0, canvas.width, canvas.height)

    this._ready = true
  }

  updateMask(percent, range) {
    if (!this._ready) {
      return
    }
    // Distance to move black and white point during scroll
    const distance = 255 + range
    const blackPoint = 255 - distance * percent

    const data = this._drawData.data
    const imageData = this._imageData.data
    const maskData = this._maskData.data
    for (let i = 0; i < data.length; i += 4) {
      const greyValue = 0.2126 * maskData[i] + 0.7152 * maskData[i + 1] + 0.0722 * maskData[i + 2]
      const leveledValue = ((greyValue - blackPoint) * 255.0) / range
      const a = clamp(leveledValue / 255.0, 0, 1)

      data[i] = imageData[i]
      data[i + 1] = imageData[i + 1]
      data[i + 2] = imageData[i + 2]
      data[i + 3] = imageData[i + 3] * a
    }
    this._context.putImageData(this._drawData, 0, 0)
  }
}

function clamp(value, min, max) {
  return Math.max(Math.min(value, max), min)
}
